var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBluetooth = function SvgBluetooth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07 9.1v4.365l2.286-2.264L9.07 9.1zm2.286-4.3L9.07 2.535v4.36l2.285-2.097zM9.07 6.894V9.1l-1.2-1.103 1.2-1.103zm-4.6 5.58l-.676-.737 4.076-3.74-4.062-3.734.677-.737 8.32 7.648-4.734 4.69V.134l4.735 4.693-8.334 7.648z"
  })));
};
export default SvgBluetooth;